import { hasValue } from 'utils/valueFormatting/display.utils';

/** Only an explicit zero confirms that a forecast period has no delays. */
const hasNoDelays = (segment) => segment.delay_time === 0 || segment.delay_time === '0';

/** Defines the status and reasons shown inside each airport forecast card. */
export const airportDelayDetails = [
  {
    id: 'status',
    label: 'Status',
    getValue: (segment) =>
      hasNoDelays(segment)
        ? 'No delays'
        : hasValue(segment.delay)
          ? segment.delay
          : 'Delay information unavailable',
  },
  {
    id: 'primaryReason',
    label: 'Primary reason',
    getValue: (segment) =>
      !hasNoDelays(segment) && hasValue(segment.primary_reason) ? segment.primary_reason : null,
  },
  {
    id: 'secondaryReason',
    label: 'Secondary reason',
    getValue: (segment) =>
      !hasNoDelays(segment) && hasValue(segment.secondary_reason) ? segment.secondary_reason : null,
  },
];
